/* eslint-disable */
import React, { PropTypes } from 'react'
import { Table, Column, Cell } from 'fixed-data-table';
import _ from 'lodash';
import $ from 'jquery';
import { browserHistory } from 'react-router';
import { DataListWrapper } from "../../../commonComponents/DataTable/DataTablePs";
// import { DataListWrapper, SortTypes, SortHeaderCell, TextCell, NewsTypeCell, TimeWithoutHHmmssCell } from "../../../commonComponents/DataTable/DataTablePs";
// import custJqAjax from '../../../commonJS/custJqAjax';

export default class AdminManageAccountDataTableCt extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      is_loading: true,
      all_data: [],
      main_role_name_sort: 'asc',
      role_name_sort: 'asc',
      department_name_sort: 'asc',
      usergroup_data: [],
      is_loaded_all_data: false,
      is_loaded_usergroup_data: false,
      width: 850,
      role_data: [],
      usergroup_data: [],
      is_loaded_role_data: false,
      is_reloaded: false,
      translation_data: [],
      is_loaded_translation_data: false
    }

    this.loadData = this.loadData.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
    this.setState({ width: document.getElementById('system_maintain').offsetWidth })
    this.loadRoleData();
    this.loadGroupData();
    this.loadTranslationData();
  }

  componentWillReceiveProps(nextProps) {

    const { main_role_name_sort } = this.state
    let sort_data = []

    if (nextProps.searchResults._data) {

      if (this.props.searchResults._data !== nextProps.searchResults._data) {

        sort_data = _.orderBy(nextProps.searchResults._data, ['main_role_name'], [main_role_name_sort])
      }
    }
    else if (nextProps.searchResults._data === undefined) {

      sort_data = _.orderBy(nextProps.filteredDataList._data, ['main_role_name'], [main_role_name_sort])
    }

    this.setState({ all_data: sort_data })
  }

  componentDidUpdate(prevProps, prevState) {

    const { is_loaded_all_data, is_loading, all_data, is_reloaded } = this.state

    if (is_loaded_all_data === true && is_loading === true || is_reloaded === true) {

      let defaultSortIndexes = [];
      let size = all_data.length;
      for (let i = 0; i < size; i++) {
        defaultSortIndexes.push(i);
      }
      this.props.returnDataListToDashboardFunc(new DataListWrapper(defaultSortIndexes, all_data), 'ManageAccount');
      this.setState({ is_loading: false, is_reloaded: false })
    }

    // const { is_loaded_all_data, is_loaded_usergroup_data, is_loading, all_data, usergroup_data, is_reloading } = this.state

    // if ( is_loaded_all_data === true && is_loaded_usergroup_data === true && is_loading === true || is_reloading === true ) {

    //   let merge_data =  all_data.map((x, y)=>{

    //                       let find_data1 = _.find( all_data, { sub_role: x.main_role } )
    //                       x.main_role_name = find_data1 !== undefined ? find_data1.role_name : '無'

    //                       let find_data2 = _.find( usergroup_data, { id: x.department_id } )
    //                       x.department_name = find_data2 !== undefined ? find_data2.name : '無'

    //                       return x;
    //                     })

    //   let defaultSortIndexes = [];
    //   let size = merge_data.length;
    //   for(let i = 0; i < size; i++){
    //     defaultSortIndexes.push(i);
    //   }
    //   this.props.returnDataListToDashboardFunc( new DataListWrapper(defaultSortIndexes, merge_data), 'Role' );
    //   this.setState({ all_data: merge_data, is_loading: false, is_reloading: false })
    // }
  }

  loadData() {

    $.ajax({
      type: 'get',
      url: '/api/W_ManageAccount_Get.php',
      success: response => {
        this.setState({ all_data: response.result, is_loaded_all_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  loadGroupData() {

    $.ajax({
      type: 'get',
      url: '/api/W_Role_Get.php',
      success: response => {
        this.setState({ role_data: response.result, is_loaded_role_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  loadRoleData() {

    $.ajax({
      type: 'get',
      url: '/api/W_UserGroup_Get.php',
      success: response => {
        this.setState({ usergroup_data: response.result, is_loaded_usergroup_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  loadTranslationData() {

    $.ajax({
      type: 'get',
      url: '/api/GetAllTranslation.php',
      success: response => {
        this.setState({ translation_data: response.result, is_loaded_translation_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    })
  }

  reloadData() {

    $.ajax({
      type: 'get',
      url: '/api/W_ManageAccount_Get.php',
      success: response => {
        this.setState({ all_data: response.result, is_reloaded: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  onRowClick(row, event) {
    event.target.className === 'btn btn-info btn-sm' ? browserHistory.push('/salesky/admin/ManageAccount/authority/' + row.user_id) : browserHistory.push('/salesky/admin/ManageAccount/' + row.user_account)
    // browserHistory.push('/salesky/admin/ManageAccount/' + row.user_account );
  }

  onSortChange(value, sort, sort_name) {

    const { all_data } = this.state

    let new_sort = sort === 'asc' ? 'desc' : 'asc'
    let sort_data = _.orderBy(all_data, [value], [new_sort])
    let new_state = {}
    new_state['all_data'] = sort_data
    new_state[sort_name] = new_sort
    this.setState(new_state)
  }

  render() {
    const { closeModal, tableHeight } = this.props
    const { is_loading, all_data, main_role_name_sort, role_name_sort, department_name_sort, width, is_loaded_role_data, role_data, is_loaded_usergroup_data, usergroup_data, translation_data, is_loaded_translation_data } = this.state
    const loading = is_loading === true ? <div className="loading" style={{ maxWidth: '900px' }}><img role="presentation" src="/imgs/loading.gif" /></div> : false

    let modal = this.props.children ? React.cloneElement(this.props.children, {
      closeModal: closeModal,
      reloadData: this.reloadData,
      is_loaded_role_data: is_loaded_role_data,
      role_data: role_data,
      is_loaded_usergroup_data: is_loaded_usergroup_data,
      usergroup_data: usergroup_data,
      translation_data: translation_data,
      is_loaded_translation_data: is_loaded_translation_data
    }) : "";

    let d = new Date().getTime()

    return (
      <div id="system_maintain" style={{ position: "relative" }}>
        {loading}
        <Table
          rowHeight={100}
          headerHeight={50}
          rowsCount={all_data.length}
          width={width}
          height={tableHeight || 477}
          onRowClick={(event, rowIndex) => this.onRowClick(all_data[rowIndex], event)} //onRowClick自帶三個props: event, rowIndex, Object
        // {...this.props}
        >
          <Column
            width={100}
            flexGrow={0}
            cell={({ rowIndex, ...props }) => (
              <img width="100%" height="100%" style={{ padding: '4px' }} src={all_data[rowIndex]['img_path'] === '' ? '/imgs/default-profile.png' : all_data[rowIndex]['img_path'] + "?v=" + d} />
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('main_role_name', main_role_name_sort, 'main_role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  圖片 { /*role_name_sort === 'asc' ? '↓' : '↑'*/}
                </a>
              </Cell>
            }
          />
          <Column
            width={250}
            flexGrow={2}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['user_name']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('main_role_name', main_role_name_sort, 'main_role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  使用者名稱 { /*role_name_sort === 'asc' ? '↓' : '↑'*/}
                </a>
              </Cell>
            }
          />
          <Column
            width={250}
            flexGrow={2}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['email']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('main_role_name', main_role_name_sort, 'main_role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  信箱 { /*role_name_sort === 'asc' ? '↓' : '↑'*/}
                </a>
              </Cell>
            }
          />
          <Column
            width={250}
            flexGrow={2}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['user_account']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('main_role_name', main_role_name_sort, 'main_role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  使用者帳號 {role_name_sort === 'asc' ? '↓' : '↑'}
                </a>
              </Cell>
            }
          />
          <Column
            width={100}
            flexGrow={0}
            cell={({ rowIndex, ...props }) => (
              <div className="flex_center_center"><button type="button" className="btn btn-info btn-sm">Edit <span className="glyphicon glyphicon-edit"></span></button></div>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('main_role_name', main_role_name_sort, 'main_role_name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  權限設定 { /*role_name_sort === 'asc' ? '↓' : '↑'*/}
                </a>
              </Cell>
            }
          />
        </Table>
        {modal}
      </div>
    )
  }
}

AdminManageAccountDataTableCt.PropTypes = {
  filteredDataList: PropTypes.object.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminManageAccountDataTable.jsx